var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: -0.352941,
  y: 0.352941,
  width: 23.2941,
  height: 23.2941,
  rx: 11.6471,
  transform: "matrix(-1 0 0 1 23.2941 0)",
  stroke: "#CCCCCC",
  strokeWidth: 0.705882
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1635 12.392L11.4853 18.1067L12.0416 18.6666L18.6665 12.0002L12.0416 5.33325L11.4853 5.92178L17.1612 11.6078H5.33323V12.392H17.1635Z",
  fill: "#333333"
})));
export default SvgIconArrow;